<template>
  <div class="">
    <UIModal
      v-if="isModalOpen"
      modal-class="flex justify-center items-center"
      modal-content-class="`relative flex flex-col max-h-full mx-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900 appointment-modal-conatiner ${popoverClass} transition-transform duration-100`"
      :show-modal="true"
      @hide="modalClosed"
      :close-on-backdrop="false"
      hide-footer
      hide-close-button
      hide-title
      :size="'sm'"
      body-class="!p-0"
      @update:show-modal="isModalOpen = $event"
    >
      <div
        id="appointmentModal"
        ref="appointmentModal"
        class="h-full w-full appointment-modal-test"
      ></div>
    </UIModal>

      <ChangeModal
      :data="afterData"
      v-if="isChangeModalOpen"
      @close="isChangeModalOpen = false"
      />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Postmate, { ParentAPI } from 'postmate'
import firebase from 'firebase/compat/app'
import { Contact, AuthUser, Location } from '../../models'
import store from '../../store'
import config from '../../config'
import { UxMessage } from '@/util/ux_message'
import ChangeModal from '../components/audit/ChangeModal.vue'
import { contactsRouteNames } from '@/routes/constants/location'
import cloneDeep from 'lodash-es/cloneDeep'
import UIModal from '@/compatibility/modal/UIModal.vue'

export default defineComponent({
  inject: ['uxmessage'],
  created() {
    this.$bus.on('open-new-appt-modal', ({source}) => {
      this.loadCalendarApp()
      this.child?.call('openCreateApptModal', {source});
      this.isModalOpen = true
    })

    this.$bus.on('open-appt-popover', (data) => {
      this.popoverClass = data && data.toString().includes('webinarId') ? 'popover-container-webinar ' :'popover-container'
      this.loadCalendarApp()
      this.child?.call('openPopover' , data);
      this.isModalOpen = true
    })

    this.$bus.on('init-cal-app', ({locationId}) => {
      this.loadCalendarApp(locationId)
    })

    this.$bus.on('open-contact-appt-modal', ({ contactId, source }) => {
      this.loadCalendarApp()
      this.child?.call('openContactApptModal', {
        contactId,
        source
      })
      this.isModalOpen = true
    })

    this.$bus.on('open-edit-appt-modal', ({eventId, source}) => {
      this.loadCalendarApp()
      this.child?.call('appointmentToBeEdited', {
        eventId,
        source
      })
      this.isModalOpen = true
    })

    this.$bus.on('open-cal-view-appt-modal', data => {
      this.loadCalendarApp()
      this.child?.call('openCalendarEventModal', data)
      this.isModalOpen = true
    })
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadCalendarApp()
    // }, 7000)
  },
  components: {
    ChangeModal,
    UIModal
  },
  data() {
    return {
      currentLocationId: '',
      popoverClass: '',
      calendarAppUrl: config.calendarAppUrl,
      isModalOpen: false,
      search: Contact.last(Contact.searchByName),
      child: null as ParentAPI | null,
      hasLoadedCalendarApp: false,
      whitelabelUrl: '',
      isChangeModalOpen: false,
      afterData: null,
      handshake: {},
    }
  },
  computed: {
		getSideBarVersion(): string {
			return this.$store.getters['sidebarv2/getVersion']
		},
    loggedInUser():any{
      return this.$store.state.user.user
    },
  },
  methods: {
    async getTokenId(): Promise<string> {
      const tokenId = await firebase.auth().currentUser?.getIdToken()
      return tokenId ?? ''
    },
    modalClosed() {
      this.child?.call('resetApptModal')
      this.isModalOpen = false
      this.afterData = null
      this.popoverClass = ''
    },
    navigateContactDetailPage(contactId: string) {
			const routeData = this.$router.resolve({ name: this.getSideBarVersion == 'v2' ? contactsRouteNames.contactDetail: 'contact_detail', params: { contact_id: contactId}})
			window.open(routeData.href, '_blank');
		},
    showToast(message: string, type: string = 'info') {
      try {
        setTimeout(() => {
          if (type === 'success')
            this.uxmessage(UxMessage.successType('', message), true)
          else this.uxmessage(UxMessage.infoType('', message), true)
        }, 1200)
      } catch {}
    },
    async loadCalendarApp(storeLocationId: string = '') {
      if (
      !storeLocationId ||
        (this.hasLoadedCalendarApp &&
         (this.currentLocationId === storeLocationId))
      )
        return
      if (this.child) this.child.destroy()
      this.currentLocationId = storeLocationId
      console.log('loadCalendarApp', this.currentLocationId)
      const location =  new Location(
        await this.$store.dispatch('locations/getCurrentLocation', this.currentLocationId)
      )
      const tokenId = await this.getTokenId()

      const auth = new AuthUser(await store.dispatch('auth/get'))
      const userId =
        firebase.auth().currentUser?.uid || this.$store.state.user.id
      const userType = this.$store.state.user?.user?.type
      const userRole = this.$store.state.user?.user?.role
       if(!this.whitelabelUrl) {
         this.whitelabelUrl = window.location.origin
       }
      this.handshake = new Postmate({
        container: this.$refs.appointmentModal,
        url: config.calendarAppURL,
        name: 'calendar-app',
        classListArray: ['h-full', 'w-full'],
        model: cloneDeep({
          locationId: this.currentLocationId,
          tokenId: tokenId,
          apiKey: location.apiKey,
          disableContactTimezone: location.disableContactTimezone,
          authApiKey: auth.apiKey,
          userId: userId,
          userType: userType,
          userRole: userRole,
          timeZone: location.timezone,
          locale: this.loggedInUser.platformLanguage || location.localeSettings.platform,
          company: {
            plan: this.$store.state.company?.company?.stripe_active_plan,
            id: this.$store.state.company?.company?.id,
          },
          whitelabelUrl: this.whitelabelUrl,
          recurringEventsEnabled: true
        }),
      })

      this.handshake.then(child => {
        child.on('getRefreshedTokenId', async () => {
          const tokenId = await this.getTokenId()
          child.call('setTokenId', tokenId)
        })

        child.on('changes-saved', message => {
          this.modalClosed()
          this.$bus.emit("calendarEventChanged");
          this.isModalOpen = false
          this.showToast(message, 'success')
        })

        child.on('appointment-create-error', data => {
          this.showToast(data.message, 'error')
        })

        child.on('open-contact-page', data => {
          this.navigateContactDetailPage(data.contactId)
        })

        child.on('open-activity-log' , data => {
            this.popoverClass = ''
             child.call('navigateToActivityLog', {
                eventId: data.eventId,
                source: "calendar_page"
              })
        })

        child.on('close-modal', () => {
          this.modalClosed()
        })

        child.on('toggle-extend-popover' , () => {
          if(this.popoverClass === 'popover-container') {
            this.popoverClass = 'popover-container-extended'
          }else {
            this.popoverClass = 'popover-container'
          }
        })

        child.on('block-slot-resize', () => {
          this.popoverClass = 'block-slot-modal'
        })

        child.on('reschedule-from-popover' , (eventId) => {
          this.modalClosed();
          this.child?.call('appointmentToBeEdited', {
                eventId: eventId,
                source: "calendar_page"
              })
          this.isModalOpen = true
        })

        child.on('reschedule-webinar-from-popover' , (data) => {
          this.modalClosed();
          this.child?.call('appointmentToBeEdited', {
                eventId: data?.eventId,
                webinarId:data?.webinarId,
                reschedule:data?.reschedule,
                appointmentIds:data?.appointmentIds,
                source: "calendar_page"
              })
          this.isModalOpen = true
        })

        child.on('copy-to-clipboard' , (text) => {
          navigator.clipboard.writeText(text)
        })

        child.on('open-change-modal' , (data) => {
          this.isChangeModalOpen = true;
          this.afterData = JSON.parse(data);
        })

        try {
          this.child = child
        } catch {}

      })

      this.hasLoadedCalendarApp = true
    },
    destroy() {
      this.handshake.then((child: any) => {
        child.destroy()
      })
    },
  },
  watch: {
    // isModalOpen(val) {
    //   if (val) {
    //     this.loadCalendarApp()
    //   }else {
    //     console.log('modalClosed: child' , this.child)
    //    if(this.child) this.child.destroy();
    //   }
    // },
  },
  beforeUnmount() {
    this.$bus.off('open-new-appt-modal')
    this.$bus.off('open-appt-popover')
    this.$bus.off('init-cal-app')
    this.$bus.off('open-contact-appt-modal')
    this.$bus.off('open-edit-appt-modal')
    this.$bus.off('open-cal-view-appt-modal')
    this.destroy()
  },
})
</script>

<style>
.appointment-modal-conatiner {
  height: 94%;
  width: 70%;
}

.popover-container {
  height: 490px !important;
  width: 380px !important;
}


.popover-container-extended {
  height: 770px !important;
  width: 380px !important;
}

.popover-container-webinar {
  height: 830px !important;
  width: 380px !important;
}

.block-slot-modal {
  height: 800px !important;
  width: 600px !important;
}

.activity-log-container {
  height: 600px !important;
  width: 680px !important;
}

@media only screen and (min-width: 1300px) {
  .appointment-modal-conatiner {
    width: 60%;
  }
}

@media only screen and (min-width: 1800px) {
  .appointment-modal-conatiner {
    height: 80%;
    width: 43%;
  }
}
</style>
